import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import { StyledPagination } from './styles'
import { removeDuplicateLocaleFromPathname } from '../../../utils/removeLocaleFromPathname'
import { getWebsiteUrl } from '../../../utils/getWebsiteUrl'

export const Pagination = ({
  onPageChange,
  pageRangeDisplayed,
  pageCount,
  href,
  initialPage,
}) => {
  const hrefBuilder = (page) => {
    if (!href) return null
    const websiteURL = getWebsiteUrl()
    const modifiedHref = href && href.startsWith('/') ? href.slice(1) : href

    return removeDuplicateLocaleFromPathname(
      `${websiteURL}${modifiedHref}?page=${page}`
    )
  }

  return (
    <StyledPagination>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={onPageChange}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={pageCount}
        previousLabel="<"
        renderOnZeroPageCount={null}
        hrefBuilder={hrefBuilder}
        initialPage={initialPage}
      />
    </StyledPagination>
  )
}

Pagination.defaultProps = {
  onPageChange: () => null,
  pageRangeDisplayed: 0,
  pageCount: 0,
  href: '',
  initialPage: 0,
}

Pagination.propTypes = {
  onPageChange: PropTypes.number,
  pageRangeDisplayed: PropTypes.number,
  pageCount: PropTypes.number,
  href: PropTypes.string,
  initialPage: PropTypes.func,
}
